export default __webpack_public_path__ + "static/media/115_sharkoak_kawai_0001.3077a2c6.png";